import React from 'react'
import {
    Box,
    Link as ChakraLink,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import {FormattedMessage} from 'react-intl'
import {useLegalPagePaths} from '../../hooks/use-legal-page-paths'

const GoogleRecatpcha = ({isStandardLogin, enabledIDPs, isLoginPage}) => {
    const styles = useMultiStyleConfig('GoogleRecaptcha', {enabledIDPs, isLoginPage})
    const {privacyPolicyPath, termsAndConditionsPath} = useLegalPagePaths()

    return (
        <Box>
            {isStandardLogin && !isLoginPage && (
                <Text {...styles.termsText} as="span">
                    <FormattedMessage
                        defaultMessage="By continuing, you agree to our {termsLink} and {privacyLink}."
                        id="login_form.message.terms_privacy"
                        values={{
                            termsLink: (
                                <Link
                                    href={termsAndConditionsPath}
                                    {...styles.termsLink}
                                >
                                    <FormattedMessage
                                        defaultMessage="Terms & Conditions"
                                        id="login_form.link.terms_conditions"
                                    />
                                </Link>
                            ),
                            privacyLink: (
                                <Link
                                    href={privacyPolicyPath}
                                    {...styles.termsLink}
                                >
                                    <FormattedMessage
                                        defaultMessage="Privacy Policy"
                                        id="login_form.link.privacy_policy"
                                    />
                                </Link>
                            )
                        }}
                    />
                </Text>
            )}
            <Text {...styles.recaptchaText} as="span">
                <FormattedMessage
                    id="google_recatpcha.message"
                    defaultMessage="This site is protected by reCAPTCHA and the Google <privacyPolicy>Privacy Policy</privacyPolicy> and <termsOfService>Terms of Service</termsOfService> apply"
                    values={{
                        privacyPolicy: (chunks) => (
                            <ChakraLink
                                {...styles.recaptchaLink}
                                href="https://policies.google.com/privacy"
                                isExternal
                            >
                                {chunks}
                            </ChakraLink>
                        ),
                        termsOfService: (chunks) => (
                            <ChakraLink
                                {...styles.recaptchaLink}
                                href="https://policies.google.com/terms"
                                isExternal
                            >
                                {chunks}
                            </ChakraLink>
                        )
                    }}
                />
            </Text>
        </Box>
    )
}

export default GoogleRecatpcha
